import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import { theme } from "@lopie/kernel-ui";

import App from "./App";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme} defaultMode="system">
      {/* v9: enableColorScheme lives here, not on the provider. Without it
          the browser's own form controls and scrollbars stay light while
          everything else goes dark. */}
      <CssBaseline enableColorScheme />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
